export const checkout = {
    cancel: 'Cancel',
    title: 'Thanks for submitting payment.',
    complete_your_informations: 'Please enter your name and phone number so we can text you when your order is ready:',
    first_name:'First Name',
    last_name: 'Last Name',
    phone_number: 'Phone Number',
    send_order_to_kitchen: 'Send my order to the kitchen!',
    sign_me_as_vip: "Sign me up to receive special offers and VIP promotions from this restaurant by SMS. If you do not check this, you will only receive your receipt for this order via SMS"
}